import { ColumnDef } from "@tanstack/react-table";
import { Link } from "@heroui/link";
import type { TFunction } from "i18next";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

import { getAuditColumns } from "@/features/Audit/getAuditColumns";
import { preprocessCountryData } from "@/components/Form/CountryPhone/data";

export type A7OPCVMIssuer = {
  id: string;
  denomination_du_sous_jacent: string;
  lei: string;
  type_de_contrepartie: string;
  code_iso_du_pays: string;
  societe_mere_id?: number;
  societe_mere_name?: string;
};

const tableName = "a7_opcvm_issuers";

export const getIssuersColumns = (t: TFunction): ColumnDef<A7OPCVMIssuer>[] => {
  const tTable = (key: string, defaultValue: string) =>
    t(`${tableName}.columns.${key}`, { ns: "tables", defaultValue });
  const tCommon = (key: string, defaultValue: string) =>
    t(`actions.${key}`, { ns: "common", defaultValue });

  return [
    {
      accessorKey: "id",
      header: tTable("id", "ID"),
    },
    {
      accessorKey: "denomination_du_sous_jacent",
      header: tTable("denomination_du_sous_jacent", "Name"),
    },
    {
      accessorKey: "code_iso_du_pays",
      header: tTable("code_iso_du_pays", "Country"),
      cell: ({ row }) => {
        return preprocessCountryData(
          "country",
          row.getValue("code_iso_du_pays"),
        );
      },
    },
    {
      accessorKey: "lei",
      header: tTable("lei", "LEI"),
    },
    {
      accessorKey: "type_de_contrepartie",
      header: tTable("type_de_contrepartie", "Counterparty type"),
    },
    {
      accessorKey: "societe_mere_name",
      header: tTable("societe_mere_name", "Parent company name"),
      cell: ({ row }) => {
        return (
          <Link
            href={toWorkspacePath(
              `/admin/a7-opcvm/a7_opcvm_issuers/${row.original.societe_mere_id}`,
            )}
            className="text-xs"
            underline="hover"
          >
            {row.getValue("societe_mere_name")}
          </Link>
        );
      },
    },
    {
      id: "actions",
      cell: ({ row }) => {
        return (
          <div className="flex justify-end">
            <Link
              href={`${window.location.pathname}/${row.getValue("id")}`}
              className="text-xs"
              underline="hover"
            >
              {tCommon("edit", "Edit")}
            </Link>
          </div>
        );
      },
    },
  ];
};

export const getIssuerAuditColumns = (t: TFunction) =>
  getAuditColumns<A7OPCVMIssuer>(getIssuersColumns(t));
